import { Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';

export const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: '/home' },
  { path: 'home', component: HomeComponent },
  {
    path: 'user',
    loadChildren: () => import('./user/user.module').then((m) => m.UserModule),
  },
  {
    path: 'suite-search',
    loadChildren: () =>
      import('./suite-search/suite-search.module').then(
        (m) => m.SuiteSearchModule
      ),
  },
  {
    path: 'new-suite-search',
    loadChildren: () =>
      import('./new-suite-search/suite-search.module').then(
        (m) => m.NewSuiteSearchModule
      ),
  },
  {
    path: 'shipment-portal',
    loadChildren: () =>
      import('./shipment-portal/shipment-portal.module').then(
        (m) => m.ShipmentPortalModule
      ),
  },
  { path: '**', redirectTo: '/home' },
];
